import * as ko from 'knockout';

import { AuthMethod } from '../contracts';
import template from './AuthLink.html';

class AuthLink {

  imageUri: ko.Observable<string> = ko.observable<string>("");
  imageAlt: ko.Observable<string> = ko.observable<string>("");
  displayName: ko.Observable<string> = ko.observable<string>("");

  // Computed properties - initialized in constructor
  hasImage: ko.PureComputed<boolean>;

  constructor(params: { method: AuthMethod }) {
    // Initialize computed properties
    this.hasImage = ko.pureComputed<boolean>(() => this.imageUri() !== null && this.imageUri() !== '');

    const lang = global.Logonme.SelectedLanguage();
    const method = params.method ?? new AuthMethod();

    this.displayName(global.Logonme.LocalizationManager.getPropertyX(method, ['displayName'], null, lang));

    const relativeUri = global.Logonme.LocalizationManager.getPropertyX(method, ['imageUrl', 'uri'], null, lang);
    if (relativeUri) {
      // TODO: fix this
      const uri = `../wasm/${relativeUri}`;
      this.imageUri(uri);
    }
    this.imageAlt(global.Logonme.LocalizationManager.getPropertyX(method, ['imageUrl', 'text'], null, lang));
  }
}

export default { viewModel: AuthLink, template: template };
